import { useEffect, useState } from 'react'

import DashboardTopBar from './DashboardTopBar'
import DashboardStageHistory from './DashboardScreens/DashboardStageHistory'
import DashboardSidePanel from './DashboardSidePanel'
import DashboardHeader from './DashboardHeader'
import DashboardDocumentsCenter from './DashboardScreens/DashboardDocumentCenter/DashboardDocumentsCenter'
import DashboardResourceCenter from './DashboardScreens/DashboardResourceCenter'
import DashboardQA from './DashboardScreens/DashboardQA'
import DashboardContactUs from './DashboardScreens/DashboardContactUs'
import { refreshAccessToken, shouldShowChartConnect, shouldShowChartInstantCalculation, shouldShowDocuments, shouldShowTaxStatusToChart, 
         showCollectionsWindow, showRefundCalculatedWindow } from '../../utilities/extensions'
import DashboardDocumentsHeader from './DashboardScreens/DashboardDocumentsHeader'
import { company, customerData } from '../../utilities/CustomerData'
import { RefundCalculatedWindow } from '../Payment/RefundCalculatedWindow'
import { useLocation, useNavigate } from 'react-router-dom'
import DashboardReferAFriend from './DashboardScreens/DashboardReferAFriend'
import DashboardChangeDays from './DashboardScreens/DashboardChangeDays'
import MobileSideBar from '../../utilities/MobileSideBar'
import { DashboardDiscountCode } from './DashboardScreens/DashboardDiscountCode'
import { WelcomeModal } from '../WelcomeModal'
import { CollectionsWindow } from './DashboardScreens/CollectionsWindow'
import { DashboardChartConnect } from './DashboardScreens/DashboardChartConnect'
import { DashboardTaxStatusChart } from './DashboardScreens/DashboardTaxStatusChart'
import { DashboardChartInstantCalculation } from './DashboardScreens/DashboardChartInstantCalculation'
import { DashboardResetAgreement } from './DashboardResetAgreement'
import { DashboardReconnectChart } from './DashboardScreens/DashboardReconnectChart'
import { apiURL } from '../../utilities/URLs'
import { DashboardFailedBankValidation } from './DashboardScreens/DashboardFailedBankValidation'
import { DashboardBankVerified } from './DashboardScreens/DasboardBankVerified'
import { DashboardESign } from './DashboardScreens/DashboardESign'
import { DashboardIssueWithDocs } from './DashboardScreens/DashboardIssueWithDocs'
import { DashboardResyncIDME } from './DashboardScreens/DashboardResyncIDME'
import { DashboardInstantOffline } from './DashboardScreens/DashboardInstantOffline'

export default function Dashboard({ showMobileSideBar, setShowMobileSideBar, setShowNavBar }) {
  const navigate = useNavigate()
  const location = useLocation()
  const currentActiveTab = location.state ? location.state.activeTab : 0

  const [activeTab, setActiveTab] = useState(0)
  const [canInstantCalc, setCanInstantCalc] = useState(false)
  const [isPreQualified, setIsPreQualified] = useState(shouldShowChartConnect())
  const [isTaxStatus, setIsTaxStatus] = useState(shouldShowTaxStatusToChart(customerData.customerStageHistory.find(stage => stage.currentStage === true)))
  const [isChartInstantCalc, setIsChartInstantCalc] = useState(shouldShowChartInstantCalculation(customerData.customerStageHistory.find(stage => stage.currentStage === true)))
  const [hasDocuments, setHasDocuments] = useState(shouldShowDocuments(customerData.customerStageHistory.find(stage => stage.currentStage === true)))
  const [hasRefund, setHasRefund] = useState(showRefundCalculatedWindow(customerData.customerStageHistory.find(stage => stage.currentStage === true)))
  const [isCollections, setIsCollections] = useState(showCollectionsWindow(customerData.customerStageHistory.find(stage => stage.currentStage === true)))
  const [resetAgreement, setResetAgreement] = useState(customerData.customerPlaidAgreement.resetAgreement)
  const [invalid8821, setInvalid821] = useState(customerData.customerLeadData.leadContact.chartStatus === 'REJECTED' || customerData.customerLeadData.leadStage.leadStageId === 'f694c99f-93d8-450b-a947-0acb7c7ac4b3')
  const [failedBankValidation, setFailedBankValidattion] = useState(customerData.customerLeadData.leadStage.leadStageId === '715b25ed-9768-4a95-8e42-0d8fe4076fa1')
  const [failedToCreateBankApplication, setFailedToCreateBankApplication] = useState(customerData.customerLeadData.leadStage.leadStageId === '0e2e7847-c112-4f15-b17f-cdf2622b4c91')
  const [bankValidated, setBankValidated] = useState(customerData.customerLeadData.leadStage.leadStageId === '515d1c17-d315-4e32-ac0f-f3aeb38e7080')
  const [issueWithDocs, setIssueWithDocs] = useState(customerData.customerLeadData.leadStage.leadStageId === 'c0dc31c8-10be-4dc0-9796-a80ca8b4bbb4')
  const [canESign, setCanESign] = useState(customerData.customerLeadData.leadStage.leadStageId === 'c82cc1f9-a5a1-46d5-bd05-23dad9a4878b')
  const [showWelcomeModal, setShowWelcomeModal] = useState(false)

  useEffect(() => {
    const handleCheckInstantCalc = async () => {
      const checkInstantCalcResponse = await fetch(`${apiURL}/api/checkCanInstantCalc`, {
        headers: {
          'Authorization': customerData.accessToken
        }
      })
      const checkInstantCalcData = await checkInstantCalcResponse.json()
      if (checkInstantCalcData.response.error) {
        if (checkInstantCalcData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleCheckInstantCalc() : navigate('/', { state: { expired: true } })
        } else
          console.error(checkInstantCalcData.response.error)
      } else
        setCanInstantCalc(checkInstantCalcData.response.canRun)
    }

    handleCheckInstantCalc()
    setShowNavBar(true)
    document.title = `${company.companyName} | Stage History`
    if (currentActiveTab)
      setActiveTab(currentActiveTab)

    setShowWelcomeModal(customerData.customerCreatedAccount)
  }, [])

  return (
    <>
      <div className='flex flex-row font-robo justify-center bg-slate-200 min-h-[calc(100vh-72px)]'>
        <div className='flex max-sm:flex-col flex-row flex-1 max-sm:items-center items-start font-robo max-w-[1250px] gap-10 lg:h-fit mt-10'>
          <DashboardSidePanel
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
          <div className='flex flex-col items-center h-full w-full'>
            <DashboardTopBar />
            {isPreQualified && (
              <div className='w-full flex flex-col items-center gap-4 mt-10'>
                <div className='bg-white p-4 rounded-md shadow-md lg:w-full w-11/12'>
                  <iframe className='w-full aspect-video' src="https://fast.wistia.net/embed/iframe/zbo3195cm1?web_component=true&seo=true" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
                <DashboardChartConnect setShowNavBar={setShowNavBar} />
              </div>
            )}
            {isTaxStatus && (
              <div className='w-full flex flex-col items-center gap-4 mt-10'>
                <div className='bg-white p-4 rounded-md shadow-md lg:w-full w-11/12'>
                  <iframe className='w-full aspect-video' src="https://fast.wistia.net/embed/iframe/zbo3195cm1?web_component=true&seo=true" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
                <DashboardTaxStatusChart setShowNavBar={setShowNavBar} />
              </div>
            )}
            {invalid8821 && (
              <DashboardReconnectChart setShowNavBar={setShowNavBar} />
            )}
            {(isChartInstantCalc && canInstantCalc) && (
              <div className='w-full flex flex-col items-center gap-4 mt-10'>
                <div className='bg-white p-4 rounded-md shadow-md lg:w-full w-11/12'>
                  <iframe className='w-full aspect-video' src="https://fast.wistia.net/embed/iframe/zbo3195cm1?web_component=true&seo=true" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
                <DashboardChartInstantCalculation
                  setIsChartInstantCalc={setIsChartInstantCalc}
                />
              </div>
            )}
            {!canInstantCalc && (
              <DashboardInstantOffline />
            )}
            {hasDocuments && (
              customerData.customerLeadData.leadStage.leadStageId === '04144458-31da-4f86-be7b-69051d6c1cc9' ? (
                customerData.customerVerificationData.customerId ? (
                  <div className='w-full flex flex-col items-center gap-4 mt-10'>
                    <div className='bg-white p-4 rounded-md shadow-md lg:w-full w-11/12'>
                      <iframe className='w-full aspect-video' src="https://fast.wistia.net/embed/iframe/p8x318i1tr?web_component=true&seo=true" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                    </div>
                    <DashboardDocumentsHeader />
                  </div>
                ) : (
                  <DashboardResyncIDME />
                )
              ) : (
                <div className='w-full mt-10'>
                  <DashboardDocumentsHeader />
                </div>
              )
            )}
            {hasRefund && (
              <div className='w-full flex flex-col items-center gap-4 mt-10'>
                <div className='bg-white p-4 rounded-md shadow-md lg:w-full w-11/12'>
                  <iframe className='w-full aspect-video' src="https://fast.wistia.net/embed/iframe/23s5nkvvis?web_component=true&seo=true" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                </div>
                <RefundCalculatedWindow />
              </div>
            )}
            {isCollections && (
              <CollectionsWindow />
            )}
            {resetAgreement && (
              <DashboardResetAgreement />
            )}
            {failedBankValidation && (
              customerData.customerVerificationData.customerId ? (
                <DashboardFailedBankValidation />
              ) : (
                <DashboardResyncIDME />
              )
              
            )}
            {(failedToCreateBankApplication && !customerData.customerVerificationData.customerId) && (
              <DashboardResyncIDME />
            )}
            {bankValidated && (
              customerData.customerVerificationData.customerId ? (
                <DashboardBankVerified />
              ) : (
                <DashboardResyncIDME />
              )
              
            )}
            {issueWithDocs && (
              customerData.customerVerificationData.customerId ? (
                <DashboardIssueWithDocs />
              ) : (
                <DashboardResyncIDME />
              )
            )}
            {canESign && (
              customerData.customerVerificationData.customerId ? (
                customerData.customerAdvanceFunding.interestAmount >= (customerData.customerAdvanceFunding.creditAmount * 0.08) && (
                  <DashboardESign />
                )
              ) : (
                <DashboardResyncIDME />
              )
            )}
            <DashboardHeader
              activeTab={activeTab}
            />
            {activeTab === 0 ? (
              <DashboardStageHistory />
            ) : activeTab === 1 ? (
              <DashboardDocumentsCenter />
            ) : activeTab === 2 ? (
              <DashboardResourceCenter />
            ) : activeTab === 3 ? (
              <DashboardQA />
            ) : activeTab === 4 ? (
              <DashboardContactUs />
            ) : activeTab === 5 ? (
              <DashboardReferAFriend />
            ) : activeTab === 6 ? (
              <DashboardChangeDays />
            ) : (
              <DashboardDiscountCode />
            )}
          </div>
        </div>
        <MobileSideBar showMobileSideBar={showMobileSideBar} setShowMobileSideBar={setShowMobileSideBar} activeTab={activeTab} setActiveTab={setActiveTab} />
      </div>
      {showWelcomeModal && (
        <WelcomeModal setShowWelcomeModal={setShowWelcomeModal} />
      )}
    </>
  )
}